<div class="card verification-card">
    <div class="card-body">
        <div class="verification-card-header">
            <span [class]="'verification-card-icon-badge ' + iconAccent">
                <i [class]="iconClass + ' verification-card-icon'"></i>
            </span>
            <h2 class="verification-card-title">{{ title }}</h2>
            <span [class]="stateChipClass">{{ stateChipLabel }}</span>
        </div>
        <p class="verification-card-description">{{ description }}</p>
        @if (cardState === 'ERROR') {
            <p class="verification-card-error">
                We couldn't load this right now. Please refresh the page to try again.
            </p>
        }
        @if (cardState === 'FAILED') {
            <ng-content select="[failed-guidance]"></ng-content>
        }
        <div class="verification-card-footer">
            <span class="verification-card-note">
                <i class="far fa-clock"></i> {{ footerNote }}
            </span>
            @if (actionLabel || secondaryActionLabel) {
                <div class="verification-card-actions">
                    @if (secondaryActionLabel) {
                        <button (click)="secondaryActionClick.emit()"
                                [disabled]="secondaryActionDisabled"
                                class="verification-action-secondary"
                                type="button">
                            {{ secondaryActionLabel }}
                        </button>
                    }
                    @if (actionLabel) {
                        <button (click)="actionClick.emit()"
                                [disabled]="actionDisabled"
                                class="orange-btn verification-action"
                                type="button">
                            {{ actionLabel }} <i class="fas fa-arrow-right"></i>
                        </button>
                    }
                </div>
            }
        </div>
    </div>
</div>
